// © 2026 KaraokeClubs. All rights reserved.

import type { Locale } from "@/lib/types";

import en from "@/public/locales/en.json";
import pl from "@/public/locales/pl.json";
import uk from "@/public/locales/uk.json";

const dictionaries: Record<Locale, Record<string, string>> = { en, pl, uk };

export function t(locale: Locale, key: string): string {
  return dictionaries[locale]?.[key] ?? dictionaries.en[key] ?? key;
}

export function getLocaleFromCookie(cookieValue: string | undefined): Locale {
  if (cookieValue === "pl" || cookieValue === "uk") return cookieValue;
  return "en";
}

export const LOCALE_NAMES: Record<Locale, string> = {
  en: "English",
  pl: "Polski",
  uk: "Українська",
};

export const LOCALES: Locale[] = ["en", "pl", "uk"];
